module.exports = __webpack_public_path__ + "img/SC8-Member_type.097df7d3.png";